export default __webpack_public_path__ + "static/media/HeadphonesBlack.3eb83150.png";